import { dissoc } from 'ramda';

export const dropTempData = dissoc('temp');
